"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHeaders = void 0;
const httpConsts_1 = require("./httpConsts");
const getSignature_1 = require("./getSignature");
const generateHeaders = ({ req, url, language, token, deviceId, apiKey, }) => {
    const parse_url = new URL(url);
    const path = parse_url.pathname;
    const getSignatureParams = {
        path,
        apiKey,
        body: req.body,
    };
    let signature = (0, getSignature_1.getSignature)(getSignatureParams);
    switch (req.config.type) {
        case httpConsts_1.RequestType.EXTERNAL:
            return {};
        case httpConsts_1.RequestType.INTERNAL:
        default:
            return {
                [httpConsts_1.HEADERS.signature]: signature,
                [httpConsts_1.HEADERS.device]: deviceId,
                [httpConsts_1.HEADERS.language]: language,
                [httpConsts_1.HEADERS.token]: token,
                [httpConsts_1.HEADERS.platform]: httpConsts_1.PLATFORM,
            };
    }
};
exports.generateHeaders = generateHeaders;
